module.exports = __webpack_public_path__ + "static/img/mobile_gywm_banner.8da9474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_gywm_banner.png
// module id = fqTC
// module chunks = 21